import { useTranslation } from '@mint-lib/i18n';
import { Delete, OverflowMenuVertical } from '@mint-lib/icons';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@mint-lib/tw-components';

import { DataFileLink } from '../atoms/DataFileLink.jsx';

interface DataFileMoreActionsProps {
  dataFileId: string;
  isEditable: boolean;
  isRemovable: boolean;
  onDeleteClick: () => void;
}

export const DataFileMoreActions = ({
  dataFileId,
  isEditable,
  isRemovable,
  onDeleteClick,
}: DataFileMoreActionsProps) => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="plain"
          size="small"
          className="data-[state=open]:outline-[2px]"
          aria-label={t('More actions')}
          data-dd-action-name="More actions"
        >
          <OverflowMenuVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[200px]">
        {isEditable && (
          <DropdownMenuItem
            onPointerLeave={(event) => event.preventDefault()}
            onPointerMove={(event) => event.preventDefault()}
          >
            <DataFileLink dataFileId={dataFileId}>
              {t('Resume import process')}
            </DataFileLink>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          className="gap-2 fill-text-error text-text-error"
          disabled={!isRemovable}
          onClick={onDeleteClick}
          onPointerLeave={(event) => event.preventDefault()}
          onPointerMove={(event) => event.preventDefault()}
        >
          <Delete />
          {t('Delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
